import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { abstractBackgroundSoft } from './BackgroundPatterns';
import { techColors, neonGlow, terminalBorder, textGlowStrong, terminalTextStyle, terminalHeaderStyle } from './TechRetroEffects';

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100vw;
  ${abstractBackgroundSoft}
  color: ${techColors.textPrimary};
  text-align: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
  ${terminalTextStyle}


  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

export const Title = styled.h1`
  font-size: 5.5em;
  color: ${techColors.neonCyan};
  margin-bottom: 0.2em;
  margin-top: -1em;
  letter-spacing: -0.02em;
  ${textGlowStrong(techColors.neonCyan)}
  ${terminalHeaderStyle}

  @media (max-width: 768px) {
    font-size: 4.5em;
    margin-top: -0.5em;
  }

  @media (max-width: 480px) {
    font-size: 3em;
    margin-top: 0;
    margin-bottom: 0.3em;
  }
`;

export const Message = styled.p`
  font-size: 1.4em;
  color: ${techColors.textSecondary};
  margin: 10px 0 30px;
  ${terminalTextStyle}

  @media (max-width: 768px) {
    font-size: 1.3em;
    margin-bottom: 25px;
  }

  @media (max-width: 480px) {
    font-size: 1.1em;
    margin-bottom: 20px;
  }
`;

export const StyledLink = styled(Link)` 
  color: ${techColors.neonCyan};
  font-size: 1.05em;
  text-decoration: none;
  font-weight: 600;
  ${terminalBorder(techColors.neonCyan)}
  padding: 12px 36px;
  border-radius: 4px;
  background: ${techColors.darkBgTertiary};
  margin-top: 20px;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  ${terminalHeaderStyle}
  
  &:hover {
    ${neonGlow(techColors.neonCyan, 'strong')}
    background: ${techColors.darkBg};
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    font-size: 1.2em;
    padding: 16px 40px;
  }

  @media (max-width: 480px) {
    padding: 14px 32px;
    font-size: 1.1em;
    margin-top: 25px;
  }
`;
